/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Events_Not_In_Team_Project_TitleInputs */



/**
* | output |
* | --- |
* | "Events Not In Team Project" |
*
* @param {Team_Sync_Events_Not_In_Team_Project_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_events_not_in_team_project_title = /** @type {((inputs?: Team_Sync_Events_Not_In_Team_Project_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Events_Not_In_Team_Project_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements non inclus dans le projet d’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse, die nicht im Teamprojekt enthalten sind")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi non presenti nel progetto di squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События, не входящие в командный проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos que no están en el proyecto de equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队项目中未包含的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクトに含まれないイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रोजेक्ट में शामिल नहीं होने वाली घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos que não fazem parte do projeto em equipe")
	return /** @type {LocalizedString} */ ("Events Not In Team Project")
});